module.exports = __webpack_public_path__ + "static/media/spades_4.f52959c4.png";